import { useEffect, useRef, useState } from 'react'
import { Spinner } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Paper, Button, Center, Divider, Group, useMediaQuery } from 'summon-ui/mantine'
import { useInventoryItems } from '@hooks'
import { useGLTF } from '@react-three/drei'
import OnboardingHeader from '../../components/OnboardingHeader'
import { useOnboardingStorage } from '../../onboarding.store'

const TITLE = 'Unlock your Zeek'
const SUBTITLE =
  'The capsule has landed safely on ZK Credo. Its countdown reaches zero. The exterior shivers with the slightest movement before the top begins to twist and light pours out. You can see something emerging…'
const UNLOCKING_CAPSULE_VIDEO = 'https://inventory-assets.summon.xyz/zksync/unlocking-capsule.mp4'

const UnlockCapsuleView = () => {
  const t = useTranslation()
  const videoRef = useRef<HTMLVideoElement>(null)
  const { nextStep, previousStep } = useOnboardingStorage()
  const [videoLoaded, setVideoLoaded] = useState(false)
  const [videoPlayed, setVideoPlayed] = useState(false)
  const isLaptopOrLess = useMediaQuery('(max-width: 1440px)')

  // as the video is playing, preload the inventory items and cache the glb files
  const { inventoryItems } = useInventoryItems({ isDNA: true })
  useEffect(() => {
    if (inventoryItems) {
      inventoryItems.forEach((item) => useGLTF.preload(item.glbUrl))
    }
  }, [inventoryItems])

  const handleVideoLoaded = () => {
    if (videoRef?.current) {
      videoRef.current.volume = 0.05
    }
    setVideoLoaded(true)
  }
  const handleVideoEnd = () => {
    setVideoPlayed(true)
  }

  useEffect(() => {
    if (videoPlayed) {
      nextStep()
    }
  }, [videoPlayed])

  return (
    <>
      <div className='h-full w-full'>
        <OnboardingHeader title={TITLE} subTitle={SUBTITLE} />

        <Paper radius='md' maw={isLaptopOrLess ? 830 : 1500} className='overflow-hidden'>
          {!videoLoaded && (
            <Center w='100%' h='100%'>
              <Spinner isFull />
            </Center>
          )}
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            ref={videoRef}
            src={UNLOCKING_CAPSULE_VIDEO}
            autoPlay
            onLoadedData={handleVideoLoaded}
            onEnded={handleVideoEnd}
            controls={false}
            className={`min-w-full h-full round-xl overflow-hidden ${!videoLoaded ? 'hidden' : ''}`}
          />
        </Paper>

        <Paper w='100%' className='md:absolute fixed bottom-0 left-0'>
          <Divider mb='md' />
          <Group justify='space-between' px='lg' mb='lg'>
            <Button variant='outline' onClick={previousStep}>
              {t('Back')}
            </Button>
            <Button className='min-w-[100px]' disabled={true} loading={true}>
              {t('Unlocking')}
            </Button>
          </Group>
        </Paper>
      </div>
    </>
  )
}
export default UnlockCapsuleView
